import { get } from '@/services/api'
import type { PortalConfigResponse } from '@/shared/types/portal'

/**
 * Public portal branding for the current domain (no auth).
 */
export async function fetchPortalConfig(): Promise<PortalConfigResponse> {
  const { data } = await get<PortalConfigResponse>('/portal-config')
  return data
}
